module.exports = function() {
  return new Worker(__webpack_public_path__ + "5c4ec3028558d3ce6ba3.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./src/services/simulator/run-simulations.worker.js
// module id = 3wfu
// module chunks = 0